<template>
  <div>
    <DxPopup
      :visible="true"
      :close-on-outside-click="true"
      :show-close-button="true"
      :wrapper-attr="{ class: 'popup-material-request' }"
      width="430"
      height="auto"
      container=".dx-viewport"
      :title="$t('confirmRequest')"
      @hiding="hide"
    >
      <div class="popup-content">
        <p class="popup-title">
          {{ $t('popUpConfirmRequest') }}
        </p>
        <div class="popup-actions">
          <f7-button
            class="btn-accept"
            fill
            outline
            type="default"
            @click="confirmAcceptance"
          >
            {{ $t('cookiesBanner.accept') }}
          </f7-button>

          <f7-button
            class="btn-cancel"
            outline
            type="normal"
            @click="hide"
          >
            {{ $t('cancel') }}
          </f7-button>
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    DxPopup,
  },
  data() {
    return {
      RequestCode: '',
    };
  },
  computed: {
    ...mapState('materialRequest', [
      'materialsSelected',
      'acceptRequestPopup',
      'materialsRequest',
      'requestCode',
    ]),
  },
  methods: {
    hide() {
      this.setAcceptRequestPopup(false);
    },
    async confirmAcceptance() {
      try {
        this.$f7.preloader.show();
        await this.registerMaterialRequest(this.materialsRequest);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t('faillyRequested'),
            width: 450,
          },
          'info',
          2000
        );
      } finally {
        this.$f7.preloader.hide();
        this.hide();
        this.setConfirmPopup(true);
      }
    },
    ...mapActions('materialRequest', [
      'setAcceptRequestPopup',
      'registerMaterialRequest',
      'setConfirmPopup',
    ]),
  },
};
</script>

<style>
/* .popup-content {
  padding: 30px;
  text-align: center;
} */

.popup-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  color: var(--Neutral-70, #3e3c44);
}

.materials-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.materials-list li {
  margin: 5px 0;
  font-size: 1.1rem;
}

.popup-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
}

.btn-accept {
  color: white;
  padding: 0px 20px;
  border-radius: 8px;
  font-size: 1rem;
}

.btn-cancel {
  color: #6c757d;
  padding: 0px 20px;
  border-radius: 8px;
  font-size: 1rem;
  border: 1px solid #6c757d;
}

.popup-material-request
  .dx-overlay-content.dx-popup-normal.dx-resizable.dx-popup-flex-height {
  width: 500px !important;
  max-width: 90vw !important;
}
.popup-material-request .dx-popup-title {
  background: white !important;
  border-bottom: none !important;
}
.popup-material-request .dx-popup-title .dx-toolbar-label {
  color: #04589f !important;
  font-size: 20px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
}
.popup-material-request .dx-popup-content {
  max-height: 70vh !important;
  overflow-y: auto !important;

  padding: 24px !important;
}
</style>
